import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-enterprise';
import { IconSanitizerService } from 'ngx-lib';

export interface ICustomHeaderParams {
    icon: string;
}

@Component({
    selector: 'app-custom-header',
    templateUrl: './custom-header.component.html',
    styleUrls: ['./custom-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class CustomHeaderComponent implements IHeaderAngularComp {
    params!: IHeaderParams & ICustomHeaderParams;

    constructor(private readonly iconSanitizer: IconSanitizerService) {}

    iconKey?: string;
    starIcon?: SafeHtml;

    agInit(params: IHeaderParams<any, any> & ICustomHeaderParams): void {
        this.params = params;
        this.iconKey = this.params.icon;
        this.starIcon = this.iconSanitizer.getIcon(this.params.icon ?? 'star');
    }

    refresh(): boolean {
        return false;
    }
}
